/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModuleEditorStore from 'InpageEditorUI/lib/ModuleEditorStore';
import { moduleHtmlRequested, saveAndTriggerRefresh, sectionHtmlRequested } from 'InpageEditorUI/eventsAsActions/moduleEventsAsActions';
import { getContainers, getClonedModulesPendingDomOperations, getAllLayoutSectionTreesAsMap, getAllGridLayoutTreesAsMap, getModuleMetaData, getModuleUndoCount, getModuleUndoRedoCount, getModules, getMapOfClonedToOldStaticSectionName } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { didLayoutUpdate } from 'layout-dnd-utils/layoutTreeCompare';
import { TREE_COUNT_CHANGED, TREE_STRUCTURE_CHANGED } from 'layout-dnd-utils/constants/layoutTreeChangeConstants';
import { getContainerElementByName, removeActiveClass, addActiveClass, hydrateHtmlStringIntoDomElement, replaceModuleNameInHtml } from 'InpageEditorUI/lib/dom';
import { clearClonedModulesQueue, clearClonedStaticSectionsMap } from 'ContentEditorUI/redux/actions/inpageActions';
import { logInpageSeleniumEvent } from 'InpageEditorUI/eventsAsActions/seleniumEventsAsActions';
import { layoutSectionNodePositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import VersionedDomElementCache from 'layout-dnd-utils/VersionedDomElementCache';
import ContentCssAssetContainer from 'InpageEditorUI/containers/ContentCssAssetContainer';
import LayoutSectionLayoutStyleContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionLayoutStyleContainer';
import LayoutSectionEmptyPlaceholdersContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionEmptyPlaceholdersContainer';
import { getShowStaleModulesDebug } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
import { renderModuleWithWrappingHTML } from 'InpageEditorUI/lib/layoutSection/wrappingHtmlRenderUtils';
import { renderDndAreasFromLayoutTrees } from 'layout-dnd-utils/render/renderDndAreas';
import { addTreeIdsToRowsInDom } from 'layout-dnd-utils/render/renderRows';
import IframeModuleMarkupRequestManager from 'ContentUtils/helpers/IframeModuleMarkupRequestManager';
import { getSmartViewCriterionId } from 'ContentEditorUI/redux/selectors/smartViewSelectors';
import { getIsSmartContentPreview } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getIsUngatedForScpModuleInsertion, getCanUseFixedLayoutSectionsFeature } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getIsBlogPost } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { selectModuleOverrides } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getDndAreaStaticSectionElementByIdInTree } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import ModuleDomNodeStore from 'InpageEditorUI/lib/ModuleDomNodeStore';
import get from 'hs-lodash/get';
import { getHasInlineEditor } from '../lib/inlineEditingUtils';
import { forEachTree } from 'layout-dnd-utils/layoutTreeIterators';
import { getImmutableOrPlain, maybeToJS, isImmutable, hasOwn } from 'ContentEditorUI/utils/dataHelpers';
const LS_MODULE_DOM_STALE_JS_CLASS = 'hs-ls-stale-module-dom-js';
const LS_MODULE_DOM_STALE_CSS_CLASS = 'hs-ls-stale-module-dom-css';
import { renderDndAreasFromGridLayoutTrees } from 'layout-dnd-utils/grids/render/render';
import GridLayoutStyleContainer from 'InpageEditorUI/containers/gridLayout/GridLayoutStyleContainer';
import { setNodeStyles } from 'ContentEditorUI/redux/actions/gridsModuleActions';
import { computeGridLayoutTreeMapDiff } from 'layout-data-lib/GridLayoutDataTree/diffUtils';

// AKA "Remy" (REnderMangerY)
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ModuleDomRenderContainer extends Component {
  constructor(props) {
    super(props);
    // Make sure cache is atleast big enough to handle the amount
    // of modules on the page
    this.initMarkupRequestManager = bus => {
      this.markupRequestManager = new IframeModuleMarkupRequestManager({
        onMarkupReceived: this.handleModuleMarkupReceived,
        onMarkupRequest: this.handleModuleMarkupRequest
      });
      bus.on('post:htmlReceivedForModule', this.markupRequestManager.handleNewMarkupResponse);
      bus.on('post:moduleHtmlRequiresRefresh', this.markupRequestManager.handleRefreshRequiredResponse);
      this.sectionMarkupRequestManager = new IframeModuleMarkupRequestManager({
        onMarkupReceived: this.handleSectionMarkupReceived,
        onMarkupRequest: this.handleSectionMarkupRequest
      });
      bus.on('post:htmlReceivedForSection', this.sectionMarkupRequestManager.handleNewMarkupResponse);
    };
    this.handleModuleMarkupRequest = (moduleName, moduleVersion, options) => {
      const {
        bus
      } = this.props;
      bus.dispatchActionToEventBus(moduleHtmlRequested(moduleName, moduleVersion, options));
    };
    this.handleModuleMarkupReceived = (moduleName, moduleVersion, moduleDomNode) => {
      this.cache.addCacheEntry(moduleName, moduleVersion, moduleDomNode);
    };
    this.handleSectionMarkupRequest = (sectionName, sectionVersion, __options) => {
      const {
        bus
      } = this.props;
      bus.dispatchActionToEventBus(sectionHtmlRequested(sectionName, sectionVersion));
    };
    this.handleSectionMarkupReceived = (sectionName, sectionVersion, sectionDomNode) => {
      this.cache.addCacheEntry(sectionName, sectionVersion, sectionDomNode);
    };
    this.checkForChangesViaPostBodyDnd = newModules => {
      const {
        isBlogPost
      } = this.props;
      if (!isBlogPost) {
        return false;
      }
      const hasNewPostBodyDndModule = Boolean(newModules.some(module => module && module.get('parent_name') === 'post_body'));
      return hasNewPostBodyDndModule;
    };
    this.checkForChangesToPostBodyModule = changedModules => {
      const {
        isBlogPost
      } = this.props;
      if (!isBlogPost) {
        return false;
      }
      return Boolean(changedModules.some(module => module && module.get('name') === 'post_body'));
    };
    this.checkForChangesToModulesInRichText = changedModules => {
      if (!this.getIsScpModuleInsertionEnabled()) {
        return false;
      }
      return Boolean(changedModules.some(module => module && module.get('parent_name')));
    };
    this.getHasDataTokenPropertiesThatChanged = (scpDataTokens, changedProperties) => {
      return Boolean(changedProperties.some(changedProperty => scpDataTokens.indexOf(changedProperty) > -1));
    };
    this.checkForGridLayoutChanges = (previousTrees, currentTrees) => {
      const {
        numberTreesChanged: gridLayoutNumberTreesChanged,
        diffsByTreeId: gridLayoutDiffsByTreeId
      } = computeGridLayoutTreeMapDiff(currentTrees, previousTrees);
      const hasGridTreeStructureChanged = Object.keys(gridLayoutDiffsByTreeId).some(treeId => {
        const {
          addedSections = [],
          removedSections = [],
          addedContainers = [],
          removedContainers = [],
          addedModules = [],
          removedModules = [],
          changedContainers = [],
          changedSections = [],
          changedRootNodeChildren = false
        } = gridLayoutDiffsByTreeId[treeId] || {};
        return addedSections.length > 0 || removedSections.length > 0 || addedContainers.length > 0 || removedContainers.length > 0 || addedModules.length > 0 || removedModules.length > 0 || changedContainers.length > 0 || changedSections.length > 0 || changedRootNodeChildren;
      });
      return gridLayoutNumberTreesChanged || hasGridTreeStructureChanged;
    };
    this.checkForStaticSectionChanges = ({
      treeStructureChangedResult,
      previousTrees,
      currentTrees,
      canUseFixedLayoutSections
    }) => {
      const addedStaticSections = [];
      const deletedStaticSections = [];
      if (!treeStructureChangedResult || !canUseFixedLayoutSections) {
        // Return empty arrays - so we know not to do anything
        return {
          staticSectionToAdd: undefined,
          staticSectionToDelete: undefined
        };
      }
      // Iterate over previous trees to find any static sections removed
      Object.values(previousTrees).forEach(tree => {
        for (const deletedNodes of treeStructureChangedResult.deletedNodeNames.values()) {
          if (tree.hasRow(deletedNodes)) {
            const deletedRow = tree.findRow(deletedNodes);
            if (deletedRow.isStaticSection()) {
              deletedStaticSections.push(deletedRow);
            }
          }
        }
      });
      // Iterate over new tree to find any static sections added
      Object.values(currentTrees).forEach(tree => {
        for (const addedNodes of treeStructureChangedResult.addedNodeNames.values()) {
          if (tree.hasRow(addedNodes)) {
            const addedRow = tree.findRow(addedNodes);
            if (addedRow.isStaticSection()) {
              addedStaticSections.push(addedRow);
            }
          }
        }
      });
      return {
        staticSectionToAdd: addedStaticSections[0],
        staticSectionToDelete: deletedStaticSections[0]
      };
    };
    this.checkForEmbedChanges = ({
      treeStructureChangedResult,
      currentTrees
    }) => {
      if (!treeStructureChangedResult) {
        return {
          embedToAdd: null
        };
      }
      let embedToAdd;
      Object.values(currentTrees).forEach(tree => {
        for (const addedNodes of treeStructureChangedResult.addedNodeNames.values()) {
          if (tree.hasRow(addedNodes)) {
            const addedRow = tree.findRow(addedNodes);
            if (addedRow.isEmbed()) {
              embedToAdd = addedRow;
              // Short circuit by returning false
              return false;
            }
          }
        }
        return true;
      });
      return {
        embedToAdd
      };
    };
    this.getEmbedFromCacheByName = (embedId, version = 0) => {
      if (!embedId) {
        return null;
      }
      return this.cache.getCacheEntry(embedId, version);
    };
    this.getStaticSectionFromCacheByName = (name, version = 0) => {
      if (!name) {
        return null;
      }
      return this.cache.getCacheEntry(name, version);
    };
    this.cloneStaticSectionToCacheFromOld = (newName, oldName, version = 0) => {
      // safest way to hae most up to date copy
      const cloneSource = getDndAreaStaticSectionElementByIdInTree(oldName);
      const htmlWithNewNameInserted = replaceModuleNameInHtml(cloneSource.outerHTML, oldName, newName // new name
      );
      // Add the new entry
      this.cache.addCacheEntry(newName, version, hydrateHtmlStringIntoDomElement(htmlWithNewNameInserted));
    };
    this.createStaticSectionFromRecipeInCache = (path, newName, version = 0) => {
      const staticSectionRecipeInCache = this.cache.getCacheEntry(path, 0);
      const htmlWithNewNameInserted = replaceModuleNameInHtml(staticSectionRecipeInCache.htmlString, staticSectionRecipeInCache.name, newName);
      // Add the new entry
      this.cache.addCacheEntry(newName, version, hydrateHtmlStringIntoDomElement(htmlWithNewNameInserted));
    };
    this.getModuleElementFromCacheByName = moduleName => {
      const {
        allModules
      } = this.props;
      const module = allModules[moduleName];
      if (!module) {
        return null;
      }
      const moduleVersion = this.getEditVersionForModule(module);
      const cacheEntry = this.cache.getCacheEntry(moduleName, moduleVersion);
      this.handleFocusedModuleClasses(moduleName, cacheEntry);
      return cacheEntry;
    };
    this.handleDeleteStaticSection = ({
      nameOfStaticSectionToDelete,
      prevLayoutSectionTrees
    }) => {
      // Add to cache in case there's an undo
      const domElement = getDndAreaStaticSectionElementByIdInTree(nameOfStaticSectionToDelete);
      this.cache.addCacheEntry(nameOfStaticSectionToDelete, 0, domElement);
      this.renderLayoutSection(prevLayoutSectionTrees);
    };
    this.handleCloneStaticSection = ({
      newModules,
      mapOfClonedToOldStaticSectionName,
      staticSectionToAdd,
      prevLayoutSectionTrees
    }) => {
      const newName = staticSectionToAdd.getName();
      const oldName = mapOfClonedToOldStaticSectionName[newName];
      this.cloneStaticSectionToCacheFromOld(newName, oldName);
      this.props.clearClonedStaticSectionsMap();
      this.handleNewModuleInLayoutSection(newModules, prevLayoutSectionTrees);
    };
    this.handleAddNewStaticSection = ({
      newModules,
      staticSectionToAdd,
      prevLayoutSectionTrees
    }) => {
      const name = staticSectionToAdd.getName();
      const path = staticSectionToAdd.getPath();
      const version = 0;
      const isInCache = this.getStaticSectionFromCacheByName(name);
      const staticSectionRecipeExists = this.cache.itemIsInCache(path, version);
      // For undo/redo actions, it will already be in the cache (deleting, re-adding)
      if (isInCache) {
        this.handleNewModuleInLayoutSection(newModules, prevLayoutSectionTrees);
        return;
      }
      // If its been fetched, the recipe will be in the cache, and we can make the
      // a clone of that.
      if (staticSectionRecipeExists) {
        this.createStaticSectionFromRecipeInCache(path, name, version);
        this.handleNewModuleInLayoutSection(newModules, prevLayoutSectionTrees);
      } else {
        this.requestSectionHtmlFromServer(name, version).then(({
          moduleName: sectionName,
          moduleVersion: sectionVersion,
          isStaleRequest
        }) => {
          if (isStaleRequest) return;
          // We have the static section _DOM node_ in the cache, but not the
          // html string. When creating new instances of this cached static
          // section, we can't reuse DOM node, so instead we'll get the string
          // representation of that cached DOM node to create the recipe for new
          // instances of this static section.
          const staticSection = this.cache.getCacheEntry(sectionName, sectionVersion);
          this.addStaticSectionRecipeToCache(sectionName, path, staticSection.outerHTML, version);
          this.handleNewModuleInLayoutSection(newModules, prevLayoutSectionTrees);
        });
      }
    };
    this.maxCacheLimit = 200;
    const allModuleKeys = Object.keys(props.allModules);
    if (allModuleKeys.length > this.maxCacheLimit) {
      this.maxCacheLimit = allModuleKeys.length;
    }
    this.cache = new VersionedDomElementCache({
      cacheSizeLimit: this.maxCacheLimit
    });
    this.initMarkupRequestManager(props.bus);
    this.state = {
      layoutSectionRenderCount: 0,
      gridLayoutRenderCount: 0
    };
  }
  componentDidMount() {
    const {
      layoutSectionTrees,
      gridLayoutTrees
    } = this.props;
    this.addMissingModulesToDomCache();
    this.touchCurrentModulesInCache();
    // Add tree ids to row elements before re-rendering the dnd area. This
    // helps the render util preserve the original DOM.
    addTreeIdsToRowsInDom(layoutSectionTrees);
    this.addAllEmbedsToCache(layoutSectionTrees);
    this.addAllStaticSectionsToCache(layoutSectionTrees);
    this.renderLayoutSection(layoutSectionTrees);
    this.renderGridLayout(gridLayoutTrees);
  }
  componentDidUpdate(prevProps) {
    const {
      allModules,
      allModuleMetaData,
      modulesToClone,
      flexColumns,
      layoutSectionTrees,
      gridLayoutTrees,
      undoCount,
      undoRedoCount,
      mapOfClonedToOldStaticSectionName,
      isDataAuthoringModeActive,
      canUseFixedLayoutSections,
      moduleOverrides
    } = this.props;
    const allModuleKeys = Object.keys(allModules);
    if (allModuleKeys.length > this.maxCacheLimit) {
      this.maxCacheLimit = allModuleKeys.length;
      this.cache.setCacheSize(allModuleKeys.length);
    }
    const wasUndoAction = prevProps.undoCount !== undoCount;
    const wasUndoOrRedoAction = prevProps.undoRedoCount !== undoRedoCount;
    const {
      changedModules,
      newModules,
      oldModuleReferencesToClearFromCache,
      hasModulesRequiringIframeRefresh
    } = this.checkForModuleChanges({
      prevModules: prevProps.allModules,
      currentModules: allModules,
      prevMetaData: prevProps.allModuleMetaData,
      currentMetaData: allModuleMetaData,
      wasUndoAction,
      wasUndoOrRedoAction,
      isDataAuthoringModeActive,
      currentModuleOverrides: moduleOverrides,
      prevModuleOverrides: prevProps.moduleOverrides
    });
    // Check fixed section changes

    if (oldModuleReferencesToClearFromCache.length) {
      this.clearCacheAboveSpecificVersionOfModule(oldModuleReferencesToClearFromCache);
    }
    const {
      numberTreesChangedResult,
      treeStructureChangedResult
    } = this.checkForLayoutSectionTreeStructureChanges(prevProps.layoutSectionTrees, layoutSectionTrees);
    const hasLayoutSectionStructureChange = Boolean(numberTreesChangedResult || treeStructureChangedResult);
    const hasGridLayoutStructureChange = this.checkForGridLayoutChanges(prevProps.gridLayoutTrees, gridLayoutTrees);
    const {
      staticSectionToAdd,
      staticSectionToDelete
    } = this.checkForStaticSectionChanges({
      treeStructureChangedResult,
      previousTrees: prevProps.layoutSectionTrees,
      currentTrees: layoutSectionTrees,
      canUseFixedLayoutSections
    });
    const {
      embedToAdd
    } = this.checkForEmbedChanges({
      treeStructureChangedResult,
      currentTrees: layoutSectionTrees
    });
    const flexColumnsThatNeedReordering = this.checkForFlexColumnChanges(prevProps.flexColumns, flexColumns);
    const hasPostBodyDndChanges = this.checkForChangesViaPostBodyDnd(newModules);
    const hasPostBodyHtmlChanges = this.checkForChangesToPostBodyModule(changedModules);
    const hasScpRichTextModuleChanges = this.checkForChangesToModulesInRichText(newModules);

    // Handle cloning existing modules and adding them to the
    // module cache before the rest of the logic below gets hit
    if (prevProps.modulesToClone !== modulesToClone && modulesToClone.length > 0) {
      this.handleCloningModules();
    }
    const hasUpdatedModules = changedModules.length > 0;
    const hasNewModules = newModules.length > 0;
    const hasFlexColumnChange = flexColumnsThatNeedReordering.length > 0;
    if (canUseFixedLayoutSections && staticSectionToDelete) {
      this.handleDeleteStaticSection({
        nameOfStaticSectionToDelete: staticSectionToDelete.getName(),
        prevLayoutSectionTrees: prevProps.layoutSectionTrees
      });
    } else if (canUseFixedLayoutSections && staticSectionToAdd && prevProps.mapOfClonedToOldStaticSectionName !== mapOfClonedToOldStaticSectionName && mapOfClonedToOldStaticSectionName.size > 0) {
      this.handleCloneStaticSection({
        mapOfClonedToOldStaticSectionName,
        newModules,
        staticSectionToAdd,
        prevLayoutSectionTrees: prevProps.layoutSectionTrees
      });
    } else if (canUseFixedLayoutSections && staticSectionToAdd) {
      this.handleAddNewStaticSection({
        newModules,
        staticSectionToAdd,
        prevLayoutSectionTrees: prevProps.layoutSectionTrees
      });
    } else if (embedToAdd || hasModulesRequiringIframeRefresh) {
      // TODO: Just refreshing for now, talk about rendering later
      this.handleRefreshingIframe();
    } else if (hasUpdatedModules && hasLayoutSectionStructureChange) {
      this.handleModuleAndTreeUpdates(changedModules, prevProps.layoutSectionTrees, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
    } else if (hasPostBodyHtmlChanges && hasPostBodyDndChanges) {
      // In the case of a cloned post body/rich text dnd module, the rich text
      // HTML is updated simultaneously with the newly cloned module being created.
      // First we need to update the rich text widget to sync its HTML from redux
      // to the widget editor & its tinyMCE DOM, then handle adding the cloned
      // module to render it and initialize its widget editor.
      this.handleModuleOnlyUpdates(changedModules, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
      this.handleModuleOnlyAdds(newModules, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
    } else if (hasUpdatedModules && !hasLayoutSectionStructureChange && !hasGridLayoutStructureChange) {
      this.handleModuleOnlyUpdates(changedModules, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
    } else if (hasNewModules && (hasPostBodyDndChanges || this.getIsScpModuleInsertionEnabled() && hasScpRichTextModuleChanges) && !hasLayoutSectionStructureChange && !hasGridLayoutStructureChange) {
      this.handleModuleOnlyAdds(newModules, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
    } else if (hasNewModules && hasLayoutSectionStructureChange) {
      this.handleNewModuleInLayoutSection(newModules, prevProps.layoutSectionTrees);
    } else if (!hasNewModules && hasLayoutSectionStructureChange) {
      this.renderLayoutSection(prevProps.layoutSectionTrees);
    } else if (wasUndoOrRedoAction && hasFlexColumnChange) {
      this.handleRefreshingIframe();
    } else if (hasNewModules && hasGridLayoutStructureChange) {
      this.handleNewModuleInGridLayout(newModules, prevProps.gridLayoutTrees);
    } else if (!hasNewModules && hasGridLayoutStructureChange) {
      this.renderGridLayout(prevProps.gridLayoutTrees);
    } else if (hasUpdatedModules && hasGridLayoutStructureChange) {
      this.handleModuleAndGridLayoutTreeUpdates(changedModules, prevProps.gridLayoutTrees, {
        wasUndoAction,
        wasUndoOrRedoAction
      });
    }
    if (hasUpdatedModules || hasNewModules) {
      this.touchCurrentModulesInCache();
    }
  }
  getIsScpModuleInsertionEnabled() {
    const {
      isUngatedForScpModuleInsertion,
      isDataAuthoringModeActive,
      shouldUseModuleInsertion
    } = this.props;
    return isUngatedForScpModuleInsertion && isDataAuthoringModeActive && shouldUseModuleInsertion;
  }
  /**
   * Used to check that in the event of an undo or redo action,
   * if a given module has an inline field editor associated with it
   * __and__ that the equivalent undo/redo action could be done inline.
   * An example of an equivalent undo/redo action that could be done inline
   * could be typing in new content, hitting backspace on content, or just
   * setting the content manually inline. Basically ensuring that we don't
   * require the edit sidebar to make the equivalent changes
   */
  getHasInlineEditorThatCanLiveUpdateUndoOrRedoAction(wasUndoAction, wasRedoAction, moduleName, isCurrentStateInlineEdited, wasPreviousStateInlineEdited) {
    if (!getHasInlineEditor(moduleName)) {
      return false;
    }
    return wasUndoAction && wasPreviousStateInlineEdited || wasRedoAction && isCurrentStateInlineEdited;
  }
  checkForModuleChanges({
    prevModules,
    currentModules,
    prevMetaData,
    currentMetaData,
    wasUndoOrRedoAction,
    wasUndoAction,
    isDataAuthoringModeActive,
    currentModuleOverrides,
    prevModuleOverrides
  }) {
    const changedModules = [];
    const newModules = [];
    let hasModulesRequiringIframeRefresh = false;
    // Maybe slow? Maybe assume that every module is unique and remove it from
    // prevModules if we've seen it in the currentModules loop? Then our removed
    // modules are whatever is left from the prevModules?
    Object.keys(prevModules).forEach(moduleName => {
      if (!hasOwn(currentModules, moduleName)) {
        ModuleDomNodeStore.delete(moduleName);
      }
    });
    const oldModuleReferencesToClearFromCache = [];
    const wasRedoAction = wasUndoOrRedoAction && !wasUndoAction;

    // Figure out what module versions changed here
    Object.entries(currentModules).forEach(([key, currentModule]) => {
      const moduleName = currentModule.get('name');
      const isCurrentStateInlineEdited = currentMetaData.getIn([moduleName, 'inlineEdited']);
      const wasPreviousStateInlineEdited = prevMetaData.getIn([moduleName, 'inlineEdited']);
      // Defer to either the WidgetEditor or inline field editor if the current state
      // is inline edited __and__ the action wasn't an undo or redo action. If the action
      // __was__ an undo/redo action, check to see if we have an inline field editor that
      // can apply the undo/redo action for us. If we do, defer to that inline field
      // editor instead.
      if (isCurrentStateInlineEdited && !wasUndoOrRedoAction || this.getHasInlineEditorThatCanLiveUpdateUndoOrRedoAction(wasUndoAction, wasRedoAction, moduleName, isCurrentStateInlineEdited, wasPreviousStateInlineEdited)) {
        return;
      }
      const previousModule = prevModules[key];
      if (!previousModule) {
        newModules.push(currentModule);
      } else {
        const editVersionKey = [moduleName, 'editVersion'];
        const currentModuleVersion = currentMetaData.getIn(editVersionKey);
        const previousModuleVersion = prevMetaData.getIn(editVersionKey);
        const moduleHiddenKey = [moduleName, 'hidden'];
        const currentModuleIsHidden = get(currentModuleOverrides, moduleHiddenKey);
        const previousModuleIsHidden = get(prevModuleOverrides, moduleHiddenKey);
        if (isDataAuthoringModeActive && currentModuleIsHidden !== previousModuleIsHidden) {
          hasModulesRequiringIframeRefresh = true;
        } else if (currentModuleVersion !== previousModuleVersion) {
          changedModules.push(currentModule);
        }

        // If we are in a "detached head" cache state, where someone undid abunch
        // of edits, then made _new_ edits, we should detect this and blow away any
        // dom nodes greater than the previous version because they are "stale" and
        // kind of in a parallel universe, we don't want to reuse those same
        // cached nodes for _new_ versions in this parallell universe. It's
        // kind of like the Flash when he went back and time and screwed up the timeline. #flashpoint
        if (currentModuleVersion > (previousModuleVersion || 0) && !wasUndoOrRedoAction) {
          oldModuleReferencesToClearFromCache.push({
            moduleName,
            versionToStartDeletingFrom: currentModuleVersion
          });
        }
      }
    });
    return {
      changedModules,
      newModules,
      oldModuleReferencesToClearFromCache,
      hasModulesRequiringIframeRefresh
    };
  }
  checkForLayoutSectionTreeStructureChanges(prevTrees, newTrees) {
    const {
      [TREE_COUNT_CHANGED]: numberTreesChangedResult,
      [TREE_STRUCTURE_CHANGED]: treeStructureChangedResult
    } = didLayoutUpdate(prevTrees, newTrees);
    return {
      numberTreesChangedResult,
      treeStructureChangedResult
    };
  }
  checkForFlexColumnChanges(prevFlexColumns, currentFlexColumns) {
    const flexColumnsThatNeedReordering = [];
    Object.entries(currentFlexColumns).forEach(([flexColumnName, currentFlexColumn]) => {
      const prevFlexColumn = prevFlexColumns[flexColumnName];
      const currentModuleList = currentFlexColumn.get('widgets');
      const previousModuleList = prevFlexColumn.get('widgets');
      const currentModuleListSize = isImmutable(currentModuleList) ? currentModuleList.size : currentModuleList.length;
      const previousModuleListSize = isImmutable(previousModuleList) ? previousModuleList.size : previousModuleList.length;
      if (currentModuleListSize !== previousModuleListSize) {
        flexColumnsThatNeedReordering.push(currentFlexColumn);
        return;
      }
      for (let i = 0; i < currentModuleListSize; i++) {
        const currentModule = isImmutable(currentModuleList) ? currentModuleList.get(i) : currentModuleList[i];
        const currentModuleName = currentModule.get('name');
        const previousModuleName = prevFlexColumn.getIn(['widgets', i, 'name']);
        if (currentModuleName !== previousModuleName) {
          flexColumnsThatNeedReordering.push(currentFlexColumn);
          break;
        }
      }
    });
    return flexColumnsThatNeedReordering;
  }
  logModuleRendersToSelenium(moduleNames) {
    const {
      bus
    } = this.props;
    if (window.SELENIUM_IS_RUNNING && moduleNames.length) {
      const currentTime = Date.now();
      const data = {};
      moduleNames.forEach(moduleName => {
        data[moduleName] = currentTime;
      });
      bus.dispatchActionToEventBus(logInpageSeleniumEvent('moduleRenderTimes', data));
    }
  }
  addAllEmbedsToCache(layoutTrees) {
    forEachTree(layoutTrees, tree => {
      const root = tree.getRootCell();
      root.getRows().forEach(row => {
        if (row.isEmbed()) {
          const value = row.getValue();
          const embedId = value && value.params && value.params.embed_id;
          const element = document.querySelector(`[data-embed-row-id=${row.getName()}]`);
          if (element && embedId) {
            this.cache.addCacheEntry(embedId, 0, element);
          } else {
            console.error('Embed element not found');
          }
        }
      });
    });
  }
  addAllStaticSectionsToCache(layoutTrees) {
    forEachTree(layoutTrees, tree => {
      const root = tree.getRootCell();
      root.getRows().forEach(row => {
        if (row.isStaticSection()) {
          const staticSectionId = row.getName();
          const element = document.querySelector(`[data-fixed-layout-section-id="${staticSectionId}"]`);
          if (element && staticSectionId) {
            this.cache.addCacheEntry(staticSectionId, 0, element);
          } else {
            console.error('Static section element not found');
          }
        }
      });
    });
  }
  addStaticSectionRecipeToCache(name, id, htmlString, version = 0) {
    this.cache.addCacheEntry(id, version, {
      htmlString,
      name
    });
  }
  addMissingModulesToDomCache() {
    const {
      allModules
    } = this.props;
    Object.values(allModules).forEach(module => {
      const moduleName = module.get('name');
      const moduleVersion = this.getEditVersionForModule(module);
      if (!this.cache.itemIsInCache(moduleName, moduleVersion)) {
        const moduleElement = getContainerElementByName(moduleName);
        if (moduleElement) {
          this.cache.addCacheEntry(moduleName, moduleVersion, moduleElement);
        }
      }
    });
  }
  requestModuleHtmlFromServer(module, options) {
    const moduleName = module.get('name');
    const moduleVersion = this.getEditVersionForModule(module);
    return this.markupRequestManager.requestMarkup(moduleName, moduleVersion, options);
  }
  requestSectionHtmlFromServer(sectionName, sectionVersion) {
    return this.sectionMarkupRequestManager.requestMarkup(sectionName, sectionVersion);
  }
  getEditVersionForModule(module) {
    const {
      allModuleMetaData
    } = this.props;
    const moduleName = module.get('name');
    return allModuleMetaData.getIn([moduleName, 'editVersion']) || 0;
  }
  clearCacheAboveSpecificVersionOfModule(modulesToClearFromCache) {
    modulesToClearFromCache.forEach(({
      moduleName,
      versionToStartDeletingFrom
    }) => {
      // There is no getting back to these module versions, so delete them
      // from the cache to save memory and from the recentlyUsedCacheItems to
      // prevent accidently purging another module prematurely
      this.cache.removeCacheEntryVersionsAboveSpecificVersion(moduleName, versionToStartDeletingFrom);
    });
  }
  touchCurrentModulesInCache() {
    const {
      allModules
    } = this.props;

    // Add all the current module / versions to the recently used list
    Object.values(allModules).forEach(module => {
      const moduleName = module.get('name');
      const moduleVersion = this.getEditVersionForModule(module);
      this.cache.touchCacheEntry(moduleName, moduleVersion);
    });
  }
  handleCloningModules() {
    const {
      modulesToClone,
      allModules
    } = this.props;
    modulesToClone.forEach(clonedModule => {
      // Get the names and versions of the old module
      // so we can grab the dom element from the cache
      const originalModuleName = clonedModule.originalModule;
      const originalModule = allModules[originalModuleName];
      const originalModuleVersion = this.getEditVersionForModule(originalModule);
      const newModuleName = clonedModule.newModule;

      // Only add this cloned module to the cache once
      if (!this.cache.itemIsInCache(newModuleName, 0)) {
        // Make sure any missing modules are in the cache (mostly for inline edited modules that
        // typically don't get added to the cache unless a layout change occured).
        this.addMissingModulesToDomCache();

        // Grab the outerHTML of the dom element from the cache
        const cachedDomNode = this.cache.getCacheEntry(originalModuleName, originalModuleVersion);
        if (!cachedDomNode) {
          return;
        }
        const originalModuleHtml = cachedDomNode.outerHTML;
        const newModuleHtml = replaceModuleNameInHtml(originalModuleHtml, originalModuleName, newModuleName);

        // Rehydrate the new html string into a dom node, and add it to the
        // cache for the new module name
        const newModuleDomNode = hydrateHtmlStringIntoDomElement(newModuleHtml);
        this.cache.addCacheEntry(newModuleName, 0, newModuleDomNode);
      }
    });

    // Clear out the queue of modules to clone
    this.props.clearClonedModulesQueue();
  }

  // Returns module's default or smart content
  getModuleBody(changedModule) {
    const {
      isSmartContentPreview,
      selectedSmartRuleId
    } = this.props;
    let moduleBody = changedModule.get('body');
    if (isSmartContentPreview && selectedSmartRuleId && changedModule.has('smart_objects')) {
      const smartObjects = changedModule.get('smart_objects');
      const selectedSmartRule = smartObjects.find(smartRule => getImmutableOrPlain(smartRule, 'criterion_id') === selectedSmartRuleId);
      if (selectedSmartRule) {
        if (isImmutable(moduleBody)) {
          moduleBody = moduleBody.merge(getImmutableOrPlain(selectedSmartRule, 'body'));
        } else {
          moduleBody = Object.assign({}, moduleBody, getImmutableOrPlain(selectedSmartRule, 'body'));
        }
      }
    }
    return moduleBody;
  }

  // Returns all the modules that cannot live update, and whether they are
  // in the cache or not
  liveUpdateChangedModules(changedModules, {
    wasUndoAction,
    wasUndoOrRedoAction
  }) {
    const {
      allModuleMetaData
    } = this.props;
    const result = {
      modulesInCache: [],
      modulesNotInCache: []
    };
    const modulesThatLiveUpdated = [];
    changedModules.forEach(changedModule => {
      const moduleName = changedModule.get('name');
      const moduleVersion = this.getEditVersionForModule(changedModule);
      const widgetEditor = ModuleEditorStore.get(moduleName);
      const moduleBody = maybeToJS(this.getModuleBody(changedModule));
      const isHiddenOnSmartRule = moduleBody.hide_module_and_wrapper;
      if (widgetEditor && widgetEditor.canPerformLiveUpdate(moduleBody) && !isHiddenOnSmartRule) {
        // Widget editors are still expecting this method to be called with an object and value property, like when it was updated
        // directly via post message
        widgetEditor.updatePreviewWidget(moduleBody, {
          moduleMetaData: allModuleMetaData.get(moduleName),
          wasUndo: wasUndoAction,
          wasUndoOrRedo: wasUndoOrRedoAction
        });
        modulesThatLiveUpdated.push(moduleName);
      } else if (this.cache.itemIsInCache(moduleName, moduleVersion) && moduleVersion > 0) {
        // TODO: Sometimes inline editable modules return "canPerformLiveUpdate" == false when undoing to its initial state
        // because the initial module body is missing the proper values to update. This can break things because remy assumes
        // that inline editable modules can be live updated to any state. On this check we basically say "any time a module update happens
        // and that update is making the module version be 0 again, make a round trip to the server to get new markup"
        result.modulesInCache.push(changedModule);
      } else {
        result.modulesNotInCache.push(changedModule);
      }
    });
    this.logModuleRendersToSelenium(modulesThatLiveUpdated);
    return result;
  }
  handleModuleOnlyAdds(addedModules, {
    wasUndoAction,
    wasUndoOrRedoAction
  } = {}) {
    const {
      isSmartContentPreview,
      selectedSmartRuleId
    } = this.props;
    const {
      modulesInCache,
      modulesNotInCache
    } = this.liveUpdateChangedModules(addedModules, {
      wasUndoAction,
      wasUndoOrRedoAction
    });
    this.logModuleRendersToSelenium(modulesInCache.map(m => m.get('name')));
    modulesInCache.forEach(module => {
      const moduleVersion = this.getEditVersionForModule(module);
      this.swapModuleDomNode(module, moduleVersion);
    });
    modulesNotInCache.forEach(module => {
      this.requestModuleHtmlFromServer(module, {
        refreshOnFail: true,
        smartRuleModuleBody: isSmartContentPreview && selectedSmartRuleId ? maybeToJS(this.getModuleBody(module)) : {}
      }).then(({
        moduleName,
        moduleVersion,
        isStaleRequest,
        moduleHasJs,
        moduleHasCss
      }) => {
        if (!isStaleRequest && !moduleHasJs && !moduleHasCss) {
          this.logModuleRendersToSelenium([moduleName]);
          this.swapModuleDomNode(module, moduleVersion);
        } else if (moduleHasJs || moduleHasCss) {
          this.markModuleDomAsStale({
            moduleName,
            moduleHasJs,
            moduleHasCss
          });
        }
      });
    });
  }
  handleModuleOnlyUpdates(changedModules, {
    wasUndoAction,
    wasUndoOrRedoAction
  } = {}) {
    const {
      isSmartContentPreview,
      selectedSmartRuleId
    } = this.props;
    const {
      modulesInCache,
      modulesNotInCache
    } = this.liveUpdateChangedModules(changedModules, {
      wasUndoAction,
      wasUndoOrRedoAction
    });
    this.logModuleRendersToSelenium(modulesInCache.map(m => m.get('name')));
    modulesInCache.forEach(module => {
      const moduleVersion = this.getEditVersionForModule(module);
      this.swapModuleDomNode(module, moduleVersion);
    });
    modulesNotInCache.forEach(module => {
      this.requestModuleHtmlFromServer(module, {
        refreshOnFail: wasUndoOrRedoAction,
        smartRuleModuleBody: isSmartContentPreview && selectedSmartRuleId ? maybeToJS(this.getModuleBody(module)) : {}
      }).then(({
        moduleName,
        moduleVersion,
        isStaleRequest,
        moduleHasJs,
        moduleHasCss
      }) => {
        if (!isStaleRequest && !moduleHasJs && !moduleHasCss) {
          this.logModuleRendersToSelenium([moduleName]);
          this.swapModuleDomNode(module, moduleVersion);
        } else if (moduleHasJs || moduleHasCss) {
          this.markModuleDomAsStale({
            moduleName,
            moduleHasJs,
            moduleHasCss
          });
        }
      });
    });
  }
  handleModuleAndTreeUpdates(changedModules, prevLayoutSectionTrees, {
    wasUndoAction,
    wasUndoOrRedoAction
  } = {}) {
    const {
      modulesNotInCache
    } = this.liveUpdateChangedModules(changedModules, {
      wasUndoAction,
      wasUndoOrRedoAction
    });
    const moduleMarkupRequests = [];
    modulesNotInCache.forEach(module => {
      moduleMarkupRequests.push(this.requestModuleHtmlFromServer(module, {
        refreshOnFail: wasUndoOrRedoAction
      }));
    });
    Promise.all(moduleMarkupRequests).then(values => {
      const hadStaleRequest = values.find(v => v.isStaleRequest);
      const modulesNeedingRefresh = values.filter(v => v.moduleHasJs || v.moduleHasCss);
      if (!hadStaleRequest && !modulesNeedingRefresh.length) {
        this.renderLayoutSection(prevLayoutSectionTrees);
      } else if (modulesNeedingRefresh.length) {
        modulesNeedingRefresh.forEach(({
          moduleName,
          moduleHasJs,
          moduleHasCss
        }) => {
          this.markModuleDomAsStale({
            moduleName,
            moduleHasJs,
            moduleHasCss
          });
        });
      }
    });
  }
  handleModuleAndGridLayoutTreeUpdates(changedModules, prevLayoutSectionTrees, {
    wasUndoAction,
    wasUndoOrRedoAction
  } = {}) {
    const {
      modulesNotInCache
    } = this.liveUpdateChangedModules(changedModules, {
      wasUndoAction,
      wasUndoOrRedoAction
    });
    const moduleMarkupRequests = [];
    modulesNotInCache.forEach(module => {
      moduleMarkupRequests.push(this.requestModuleHtmlFromServer(module, {
        refreshOnFail: wasUndoOrRedoAction
      }));
    });
    Promise.all(moduleMarkupRequests).then(values => {
      const hadStaleRequest = values.find(v => v.isStaleRequest);
      const modulesNeedingRefresh = values.filter(v => v.moduleHasJs || v.moduleHasCss);
      if (!hadStaleRequest && !modulesNeedingRefresh.length) {
        this.renderGridLayout(prevLayoutSectionTrees);
      } else if (modulesNeedingRefresh.length) {
        modulesNeedingRefresh.forEach(({
          moduleName,
          moduleHasJs,
          moduleHasCss
        }) => {
          this.markModuleDomAsStale({
            moduleName,
            moduleHasJs,
            moduleHasCss
          });
        });
      }
    });
  }
  handleNewModuleInLayoutSection(newModules, prevLayoutSectionTrees) {
    const modulesThatAreNotInTheCache = newModules.filter(newModule => {
      const moduleName = newModule.get('name');
      const moduleVersion = this.getEditVersionForModule(newModule);
      return !this.cache.itemIsInCache(moduleName, moduleVersion);
    });
    // All the new modules in the layout section are already in the cache, just render
    if (!modulesThatAreNotInTheCache.length) {
      this.renderLayoutSection(prevLayoutSectionTrees);
    } else {
      const moduleMarkupRequests = [];
      modulesThatAreNotInTheCache.forEach(moduleWeNeedMarkupFor => {
        moduleMarkupRequests.push(this.requestModuleHtmlFromServer(moduleWeNeedMarkupFor, {
          refreshOnFail: true
        }));
      });
      Promise.all(moduleMarkupRequests).then(values => {
        const hadStaleRequest = values.find(v => v.isStaleRequest);
        const modulesNeedingRefresh = values.filter(v => v.moduleHasJs || v.moduleHasCss);
        if (!hadStaleRequest && !modulesNeedingRefresh.length) {
          this.renderLayoutSection(prevLayoutSectionTrees);
        } else if (modulesNeedingRefresh.length) {
          modulesNeedingRefresh.forEach(({
            moduleName,
            moduleHasJs,
            moduleHasCss
          }) => {
            this.markModuleDomAsStale({
              moduleName,
              moduleHasJs,
              moduleHasCss
            });
          });
        }
      });
    }
  }
  handleNewModuleInGridLayout(newModules, prevGridLayoutTrees) {
    const modulesThatAreNotInTheCache = newModules.filter(newModule => {
      const moduleName = newModule.get('name');
      const moduleVersion = this.getEditVersionForModule(newModule);
      return !this.cache.itemIsInCache(moduleName, moduleVersion);
    });
    // All the new modules in the layout section are already in the cache, just render
    if (!modulesThatAreNotInTheCache.length) {
      this.renderGridLayout(prevGridLayoutTrees);
    } else {
      const moduleMarkupRequests = [];
      modulesThatAreNotInTheCache.forEach(moduleWeNeedMarkupFor => {
        moduleMarkupRequests.push(this.requestModuleHtmlFromServer(moduleWeNeedMarkupFor, {
          refreshOnFail: true
        }));
      });
      Promise.all(moduleMarkupRequests).then(values => {
        const hadStaleRequest = values.find(v => v.isStaleRequest);
        const modulesNeedingRefresh = values.filter(v => v.moduleHasJs || v.moduleHasCss);
        if (!hadStaleRequest && !modulesNeedingRefresh.length) {
          this.renderGridLayout(prevGridLayoutTrees);
        } else if (modulesNeedingRefresh.length) {
          modulesNeedingRefresh.forEach(({
            moduleName,
            moduleHasJs,
            moduleHasCss
          }) => {
            this.markModuleDomAsStale({
              moduleName,
              moduleHasJs,
              moduleHasCss
            });
          });
        }
      });
    }
  }
  handleFocusedModuleClasses(moduleName, moduleElement) {
    const {
      selectedModuleName
    } = this.props;
    if (moduleElement) {
      if (selectedModuleName === moduleName) {
        addActiveClass(moduleElement);
      } else {
        removeActiveClass(moduleElement);
      }
    }
  }
  swapModuleDomNode(module, moduleVersion) {
    const moduleName = module.get('name');
    const cacheEntry = this.cache.getCacheEntry(moduleName, moduleVersion);
    if (!cacheEntry) {
      return;
    }
    this.handleFocusedModuleClasses(moduleName, cacheEntry);
    const newDomNode = cacheEntry;
    const existingDomNode = getContainerElementByName(moduleName);

    // In the rare case where we can't find the existing module on the page
    // don't attempt to look for it.
    if (!existingDomNode) {
      return;
    }
    const widgetEditor = ModuleEditorStore.get(moduleName);
    if (widgetEditor) {
      widgetEditor.removeEvents();
      widgetEditor.recycle(); // Used to tear down tinymce instances in RichText widget editor
    }
    existingDomNode.insertAdjacentElement('beforebegin', newDomNode);
    const nodeParent = existingDomNode.parentNode;
    nodeParent.removeChild(existingDomNode);
    if (widgetEditor) {
      widgetEditor.updateDomReference();
      widgetEditor.attachEvents();
      widgetEditor.updateWidgetData(module.toJS());
      ModuleDomNodeStore.set(module.get('name'), newDomNode);
    } else {
      this.handleRefreshingIframe();
    }
  }
  handleRefreshingIframe() {
    const {
      bus
    } = this.props;
    bus.dispatchActionToEventBus(saveAndTriggerRefresh());
  }
  markModuleDomAsStale({
    moduleName,
    moduleHasJs,
    moduleHasCss
  }) {
    const {
      showStaleModulesDebug
    } = this.props;
    if (showStaleModulesDebug) {
      const moduleDomNode = getContainerElementByName(moduleName);
      let moduleStaleClass;
      if (moduleHasJs) {
        moduleStaleClass = LS_MODULE_DOM_STALE_JS_CLASS;
      }
      if (moduleHasCss) {
        moduleStaleClass = LS_MODULE_DOM_STALE_CSS_CLASS;
      }
      if (moduleDomNode) {
        moduleDomNode.classList.add(moduleStaleClass);
      }
      document.body.classList.add(moduleStaleClass);
    }
  }
  renderLayoutSection(prevLayoutSectionTrees) {
    const {
      layoutSectionTrees
    } = this.props;
    const {
      layoutSectionRenderCount
    } = this.state;
    this.addMissingModulesToDomCache();
    renderDndAreasFromLayoutTrees(layoutSectionTrees, prevLayoutSectionTrees, {
      getModuleElementFromCacheByName: this.getModuleElementFromCacheByName,
      getStaticSectionFromCacheByName: this.getStaticSectionFromCacheByName,
      getEmbedFromCacheByName: this.getEmbedFromCacheByName,
      renderModuleWithWrappingHTML
    });
    this.setState({
      layoutSectionRenderCount: layoutSectionRenderCount + 1
    });

    // Update node positions after a module has been added, removed, moved, etc
    this.props.layoutSectionNodePositionsCleared();
  }
  renderGridLayout(prevGridLayoutTrees) {
    const {
      gridLayoutTrees
    } = this.props;
    const {
      gridLayoutRenderCount
    } = this.state;
    this.addMissingModulesToDomCache();
    renderDndAreasFromGridLayoutTrees(gridLayoutTrees, prevGridLayoutTrees, {
      getModuleElementFromCacheByName: this.getModuleElementFromCacheByName
    });

    // TODO: We might not need this anymore based on this comment since grid
    // layout styles are all applied through each node's namespaced classname.
    // https://git.hubteam.com/HubSpot/ContentEditorUI/blob/d1a1f567bfd5d710220c29c5ca457ab013415343/InpageEditorUI/static-1.84916/js/components/LayoutSectionStylesApplicator.js#L31-L39
    this.setState({
      gridLayoutRenderCount: gridLayoutRenderCount + 1
    });

    // Update node positions after a module has been added, removed, moved, etc
    this.props.layoutSectionNodePositionsCleared();
  }
  render() {
    // Make sure we reapply the layout styles after
    // we've finished rendering a layout section
    const {
      layoutSectionRenderCount,
      gridLayoutRenderCount
    } = this.state;
    const {
      bus,
      shouldUseCssAssets,
      gridLayoutTrees
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(LayoutSectionLayoutStyleContainer, {
        layoutSectionRenderCount: layoutSectionRenderCount
      }), /*#__PURE__*/_jsx(LayoutSectionEmptyPlaceholdersContainer, {
        dispatchActionToEventBus: bus.dispatchActionToEventBus
      }, `placeholder_${layoutSectionRenderCount + gridLayoutRenderCount}`), /*#__PURE__*/_jsx(GridLayoutStyleContainer, {
        gridLayoutTrees: gridLayoutTrees
      }), shouldUseCssAssets && /*#__PURE__*/_jsx(ContentCssAssetContainer, {
        dispatchActionToEventBus: bus.dispatchActionToEventBus
      })]
    });
  }
}
ModuleDomRenderContainer.propTypes = {
  allModules: PropTypes.object.isRequired,
  canUseFixedLayoutSections: PropTypes.bool.isRequired,
  allModuleMetaData: PropTypes.object.isRequired,
  modulesToClone: PropTypes.object.isRequired,
  mapOfClonedToOldStaticSectionName: PropTypes.object.isRequired,
  clearClonedModulesQueue: PropTypes.func.isRequired,
  clearClonedStaticSectionsMap: PropTypes.func.isRequired,
  layoutSectionNodePositionsCleared: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  flexColumns: PropTypes.object.isRequired,
  layoutSectionTrees: PropTypes.object.isRequired,
  undoCount: PropTypes.number.isRequired,
  undoRedoCount: PropTypes.number.isRequired,
  selectedModuleName: PropTypes.string,
  showStaleModulesDebug: PropTypes.bool,
  shouldUseCssAssets: PropTypes.bool,
  shouldUseModuleInsertion: PropTypes.bool,
  selectedSmartRuleId: PropTypes.number,
  isSmartContentPreview: PropTypes.bool,
  isBlogPost: PropTypes.bool,
  isDataAuthoringModeActive: PropTypes.bool.isRequired,
  isUngatedForScpModuleInsertion: PropTypes.bool.isRequired,
  moduleOverrides: PropTypes.object
};
const mapStateToProps = state => {
  return {
    allModules: getModules(state),
    canUseFixedLayoutSections: getCanUseFixedLayoutSectionsFeature(state),
    modulesToClone: getClonedModulesPendingDomOperations(state),
    mapOfClonedToOldStaticSectionName: getMapOfClonedToOldStaticSectionName(state),
    allModuleMetaData: getModuleMetaData(state),
    layoutSectionTrees: getAllLayoutSectionTreesAsMap(state),
    gridLayoutTrees: getAllGridLayoutTreesAsMap(state),
    undoCount: getModuleUndoCount(state),
    undoRedoCount: getModuleUndoRedoCount(state),
    flexColumns: getContainers(state),
    selectedModuleName: getSelectedModuleName(state),
    showStaleModulesDebug: getShowStaleModulesDebug(state),
    selectedSmartRuleId: getSmartViewCriterionId(state),
    isSmartContentPreview: getIsSmartContentPreview(state),
    shouldUseCssAssets: getFeatureFlag(FEATURE_FLAGS.cssAssets),
    shouldUseModuleInsertion: getFeatureFlag(FEATURE_FLAGS.moduleInsertion),
    isBlogPost: getIsBlogPost(state),
    isDataAuthoringModeActive: getIsDataAuthoringModeActive(state),
    isUngatedForScpModuleInsertion: getIsUngatedForScpModuleInsertion(state),
    moduleOverrides: selectModuleOverrides(state)
  };
};
const mapDispatchToProps = {
  clearClonedModulesQueue,
  clearClonedStaticSectionsMap,
  layoutSectionNodePositionsCleared,
  setNodeStyles
};
export default connect(mapStateToProps, mapDispatchToProps)(ModuleDomRenderContainer);